<template>
  <div class="login-page">
    <div class="login-box">
      <div class="title">智能回收箱仓储后台</div>
      <div class="sub">WMS Admin</div>

      <el-form ref="form" :model="form" :rules="rules" label-width="0px">
        <el-form-item prop="username">
          <el-input
            v-model="form.username"
            placeholder="请输入账号"
            prefix-icon="el-icon-user"
            clearable
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
            @keyup.enter.native="onLogin"
          />
        </el-form-item>

        <el-button type="primary" class="btn" :loading="loading" @click="onLogin">
          登 录
        </el-button>

        <div class="hint">
          示例：sysadmin / 123456
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { loginApi } from '@/api/auth'

export default {
  data() {
    return {
      loading: false,
      form: {
        username: 'sysadmin',
        password: 'RJHJWSGL@@778899'
      },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onLogin() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          // 调后端：POST /api/wms/login
          const res = await loginApi(this.form.username, this.form.password)

          // 返回示例：
          // { access_token, token_type, admin_id, username, name, realname }
          const token = res && res.access_token
          if (!token) {
            console.log('登录返回：', res)
            this.$message.error('登录成功但未返回 access_token（看控制台）')
            return
          }

          localStorage.setItem('access_token', token)
          localStorage.setItem('admin_info', JSON.stringify(res))

          this.$message.success('登录成功')
          this.$router.replace('/dashboard')
        } catch (e) {
          // 错误提示已在 request.js 里统一弹了
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page{
  width:100%;
  height:100vh;
  background:
    linear-gradient(rgba(0,0,0,.35), rgba(0,0,0,.35)),
    url('~@/assets/login-bg.jpg') no-repeat center center;
  background-size:cover;
  display:flex;
  justify-content:center;
  align-items:center;
}

.login-box{
  width:400px;
  padding:38px 34px;
  background:rgba(255,255,255,0.92);
  border-radius:14px;
  box-shadow:0 14px 50px rgba(0,0,0,0.35);
}

.title{
  text-align:center;
  font-size:22px;
  font-weight:800;
  letter-spacing:1px;
}

.sub{
  text-align:center;
  color:#6b7280;
  margin-top:8px;
  margin-bottom:22px;
}

.btn{
  width:100%;
  height:42px;
  margin-top:6px;
  border-radius:10px;
  font-size:16px;
}

.hint{
  margin-top:10px;
  text-align:center;
  font-size:12px;
  color:#94a3b8;
}

/* 输入框更圆润 */
::v-deep .el-input__inner{
  height:42px;
  border-radius:10px;
}
</style>